import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  sidebarMenu: {
    margin: '15px 0 0 0',
    paddingLeft: '0',
    borderTop: 'solid 1px #474A6B',
    '& li': {
      backgroundColor: '#323349',
      listStyle: 'none',
      cursor: 'default',
    },
    '& a': {
      textDecoration: 'none',
      color: '#FFFFFF',
      display: 'block',
      padding: '15px 12px 15px 11px',
      whiteSpace: 'nowrap',
    },
  },
  activeLink: {
    background: '#474A6B',
    zIndex: 10,
    paddingLeft: '11px!important',
  },
  sideBarText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    zIndex: 20,
    marginLeft: '8px'
  },
  finishedIcon: {
    width: '12px',
    position: 'relative',
    top: '-1px',
    left: '2px',
  },
  lockedIcon: {
    width: '10px',
    position: 'relative',
    top: '-1px',
    left: '3px',
  },
  iconWrapper: {
    float: 'right',
    position: 'relative',
    top: '5px',
    display: 'inline-block',
    width: '15px',
    height: '15px',
    borderRadius: '20px',
    padding: '2px',
  },
  minimized: {
    top: '-10px',
    left: '5px',
    border: 'solid 2px #323349',
  },
  lockedWrapperMinimized: {
    backgroundColor: '#BC0000',
  },
  finishedWrapperMinimized: {
    backgroundColor: '#347F42',
  },
}));
